module.exports = __webpack_public_path__ + "img/code-building.cb37b742.png";